import React from 'react';
import {
  Button,
  IconButton,
  Link,
  NumberInput,
  ScreenContainer,
  SimpleStyleScrollView,
  TextInput,
  withTheme,
} from '@draftbit/ui';
import { Image, Text, View } from 'react-native';
import * as GlobalStyles from '../GlobalStyles.js';
import * as AuthenticationApi from '../apis/AuthenticationApi.js';
import * as GlobalVariables from '../config/GlobalVariableContext';
import Images from '../config/Images';
import checkScreenMode from '../global-functions/checkScreenMode';
import palettes from '../themes/palettes';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import imageSource from '../utils/imageSource';
import showAlertUtil from '../utils/showAlert';
import useWindowDimensions from '../utils/useWindowDimensions';

const defaultProps = { submit: null };

const ForgotPasswordScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const setGlobalVariableValue = GlobalVariables.useSetValue();
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [errorMessage, setErrorMessage] = React.useState('');
  const [flowStep, setFlowStep] = React.useState(1);
  const [isLoading, setIsLoading] = React.useState(false);
  const [otp, setOtp] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [visibleConfirm, setVisibleConfirm] = React.useState(false);
  const [visiblePassword, setVisiblePassword] = React.useState(false);
  const inputValid = () => {
    const expr =
      /^([\w-\.]+)@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})$/;
    const passwordExpr = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\W_]{8,}$/;

    let foundError = false;

    if (email.length < 1) {
      setErrorMessage('Please enter your email');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (!expr.test(email)) {
      setErrorMessage('Please enter a valid email');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    return foundError;
  };

  const passwordValid = () => {
    const passwordExpr = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\W_]{8,}$/;

    let foundError = false;

    if (password.length < 1) {
      setErrorMessage('Please enter new password');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (!password.match(passwordExpr)) {
      setErrorMessage('Password must be at least 8 characters');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (confirmPassword.length < 1) {
      setErrorMessage('Please confirm new password');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    if (confirmPassword != password) {
      setErrorMessage('Passwords do not match');
      foundError = true;
      return foundError;
    } else {
      setErrorMessage('');
    }

    return foundError;
  };

  const resetVariables = () => {
    setEmail('');
    setOtp('');
    setPassword('');
    setConfirmPassword('');
    setErrorMessage('');
    setFlowStep(1);
  };
  const authenticationVerifyOTPPOST = AuthenticationApi.useVerifyOTPPOST();
  const authenticationInitiateForgotPasswordPOST =
    AuthenticationApi.useInitiateForgotPasswordPOST();
  const authenticationUpdatePasswordPOST =
    AuthenticationApi.useUpdatePasswordPOST();

  return (
    <ScreenContainer
      hasSafeArea={false}
      scrollable={false}
      style={StyleSheet.applyWidth(
        { backgroundColor: palettes.Brand.Background },
        dimensions.width
      )}
    >
      {/* Container */}
      <SimpleStyleScrollView
        bounces={true}
        horizontal={false}
        keyboardShouldPersistTaps={'never'}
        nestedScrollEnabled={false}
        showsHorizontalScrollIndicator={true}
        showsVerticalScrollIndicator={true}
        style={StyleSheet.applyWidth(
          {
            alignItems: [
              { minWidth: Breakpoints.Laptop, value: 'center' },
              { minWidth: Breakpoints.Mobile, value: 'stretch' },
            ],
            flex: [
              { minWidth: Breakpoints.Laptop, value: 1 },
              { minWidth: Breakpoints.Mobile, value: 1 },
            ],
            gap: [
              { minWidth: Breakpoints.Mobile, value: 30 },
              { minWidth: Breakpoints.Laptop, value: 0 },
            ],
            margin: 20,
            marginLeft: [
              { minWidth: Breakpoints.Mobile, value: '20%' },
              { minWidth: Breakpoints.Laptop, value: 0 },
            ],
            marginRight: [
              { minWidth: Breakpoints.Mobile, value: '20%' },
              { minWidth: Breakpoints.Laptop, value: 0 },
            ],
          },
          dimensions.width
        )}
      >
        {/* Logo */}
        <View
          style={StyleSheet.applyWidth(
            {
              alignItems: { minWidth: Breakpoints.Laptop, value: 'center' },
              alignSelf: 'center',
              height: { minWidth: Breakpoints.Laptop, value: '33%' },
              justifyContent: { minWidth: Breakpoints.Laptop, value: 'center' },
              margin: 20,
            },
            dimensions.width
          )}
        >
          {/* Image 2 */}
          <Image
            {...GlobalStyles.ImageStyles(theme)['Image'].props}
            resizeMode={'contain'}
            source={imageSource(Images['logocropped'])}
            style={StyleSheet.applyWidth(
              StyleSheet.compose(
                GlobalStyles.ImageStyles(theme)['Image'].style,
                {
                  height: [
                    { minWidth: Breakpoints.Desktop, value: 150 },
                    { minWidth: Breakpoints.Laptop, value: 200 },
                    { minWidth: Breakpoints.Mobile, value: 200 },
                  ],
                  width: [
                    { minWidth: Breakpoints.Desktop, value: 150 },
                    { minWidth: Breakpoints.Laptop, value: 200 },
                    { minWidth: Breakpoints.Mobile, value: 200 },
                  ],
                }
              ),
              dimensions.width
            )}
          />
        </View>
        {/* Step 1 */}
        <View
          style={StyleSheet.applyWidth(
            {
              gap: [
                { minWidth: Breakpoints.Desktop, value: 30 },
                { minWidth: Breakpoints.Laptop, value: 30 },
              ],
              marginTop: 20,
              width: [
                { minWidth: Breakpoints.Desktop, value: '20%' },
                { minWidth: Breakpoints.Laptop, value: '25%' },
              ],
            },
            dimensions.width
          )}
        >
          {/* Email */}
          <TextInput
            autoCapitalize={'none'}
            autoCorrect={true}
            changeTextDelay={500}
            onChangeText={newEmailValue => {
              try {
                setEmail(newEmailValue);
              } catch (err) {
                console.error(err);
              }
            }}
            webShowOutline={true}
            {...GlobalStyles.TextInputStyles(theme)['Mobile Login Input'].props}
            autoComplete={'email'}
            editable={flowStep === 1}
            placeholder={'Enter profile email'}
            secureTextEntry={false}
            style={StyleSheet.applyWidth(
              StyleSheet.compose(
                GlobalStyles.TextInputStyles(theme)['Mobile Login Input'].style,
                {
                  backgroundColor: {
                    minWidth: Breakpoints.Laptop,
                    value: '"rgb(255, 255, 255)"',
                  },
                }
              ),
              dimensions.width
            )}
            value={email}
          />
          {/* Warning Message */}
          <>
            {!(flowStep > 1) ? null : (
              <Text
                accessible={true}
                selectable={false}
                {...GlobalStyles.TextStyles(theme)['Text'].props}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.TextStyles(theme)['Text'].style,
                    {
                      color: [
                        {
                          minWidth: Breakpoints.Laptop,
                          value: palettes.App['App Blue Light'],
                        },
                        {
                          minWidth: Breakpoints.Mobile,
                          value: palettes.App['App Blue Light'],
                        },
                      ],
                      fontFamily: [
                        {
                          minWidth: Breakpoints.Laptop,
                          value: 'OpenSans_500Medium',
                        },
                        {
                          minWidth: Breakpoints.Mobile,
                          value: 'OpenSans_500Medium',
                        },
                      ],
                      fontSize: [
                        { minWidth: Breakpoints.Laptop, value: 16 },
                        { minWidth: Breakpoints.Mobile, value: 16 },
                      ],
                      textAlign: [
                        { minWidth: Breakpoints.Laptop, value: 'center' },
                        { minWidth: Breakpoints.Mobile, value: 'center' },
                      ],
                    }
                  ),
                  dimensions.width
                )}
              >
                {
                  'Please check your email for a code to unlock your password reset.'
                }
              </Text>
            )}
          </>
        </View>
        {/* Step 2 */}
        <>
          {!(flowStep > 1) ? null : (
            <View
              style={StyleSheet.applyWidth(
                {
                  gap: [
                    { minWidth: Breakpoints.Desktop, value: 30 },
                    { minWidth: Breakpoints.Laptop, value: 50 },
                  ],
                  marginTop: { minWidth: Breakpoints.Laptop, value: '5%' },
                  width: [
                    { minWidth: Breakpoints.Desktop, value: '20%' },
                    { minWidth: Breakpoints.Laptop, value: '25%' },
                  ],
                },
                dimensions.width
              )}
            >
              {/* OTP */}
              <NumberInput
                changeTextDelay={500}
                onChangeText={newOTPValue => {
                  try {
                    setOtp(newOTPValue);
                  } catch (err) {
                    console.error(err);
                  }
                }}
                webShowOutline={true}
                {...GlobalStyles.NumberInputStyles(theme)['Number Input'].props}
                autoComplete={'one-time-code'}
                editable={flowStep > 1}
                placeholder={'Enter Reset Code Here'}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.NumberInputStyles(theme)['Number Input'].style,
                    {
                      backgroundColor: [
                        {
                          minWidth: Breakpoints.Laptop,
                          value: palettes.Brand.White,
                        },
                        {
                          minWidth: Breakpoints.Mobile,
                          value: palettes.Brand.White,
                        },
                      ],
                      fontFamily: [
                        {
                          minWidth: Breakpoints.Laptop,
                          value: 'OpenSans_500Medium',
                        },
                        {
                          minWidth: Breakpoints.Mobile,
                          value: 'OpenSans_500Medium',
                        },
                      ],
                      fontSize: [
                        { minWidth: Breakpoints.Laptop, value: 16 },
                        { minWidth: Breakpoints.Mobile, value: 16 },
                      ],
                      paddingBottom: 12,
                      paddingTop: 12,
                    }
                  ),
                  dimensions.width
                )}
                value={otp}
              />
            </View>
          )}
        </>
        {/* Step 3 */}
        <>
          {!(flowStep > 2) ? null : (
            <View
              style={StyleSheet.applyWidth(
                {
                  gap: [
                    { minWidth: Breakpoints.Desktop, value: 30 },
                    { minWidth: Breakpoints.Laptop, value: 50 },
                    { minWidth: Breakpoints.Mobile, value: 20 },
                  ],
                  marginTop: { minWidth: Breakpoints.Laptop, value: '5%' },
                  width: [
                    { minWidth: Breakpoints.Desktop, value: '20%' },
                    { minWidth: Breakpoints.Laptop, value: '25%' },
                  ],
                },
                dimensions.width
              )}
            >
              <View>
                {/* Password */}
                <TextInput
                  autoCapitalize={'none'}
                  autoCorrect={true}
                  changeTextDelay={500}
                  onChangeText={newPasswordValue => {
                    try {
                      setPassword(newPasswordValue);
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                  webShowOutline={true}
                  {...GlobalStyles.TextInputStyles(theme)['Mobile Password']
                    .props}
                  autoComplete={'new-password'}
                  keyboardType={'visible-password'}
                  placeholder={'Enter New Password'}
                  secureTextEntry={!visiblePassword}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.TextInputStyles(theme)['Mobile Password']
                        .style,
                      {
                        backgroundColor: {
                          minWidth: Breakpoints.Laptop,
                          value: '"rgb(255, 255, 255)"',
                        },
                      }
                    ),
                    dimensions.width
                  )}
                  value={password}
                />
                <IconButton
                  onPress={() => {
                    try {
                      setVisiblePassword(!visiblePassword);
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                  color={StyleSheet.getWidthValue(
                    [
                      {
                        minWidth: Breakpoints.Laptop,
                        value: palettes.Brand.Black,
                      },
                      {
                        minWidth: Breakpoints.Mobile,
                        value: palettes.Brand.Black,
                      },
                    ],
                    dimensions.width
                  )}
                  icon={
                    visiblePassword
                      ? 'FontAwesome/eye'
                      : 'FontAwesome/eye-slash'
                  }
                  size={StyleSheet.getWidthValue(
                    [
                      { minWidth: Breakpoints.Laptop, value: 24 },
                      { minWidth: Breakpoints.Mobile, value: 24 },
                    ],
                    dimensions.width
                  )}
                  style={StyleSheet.applyWidth(
                    {
                      position: [
                        { minWidth: Breakpoints.Laptop, value: 'absolute' },
                        { minWidth: Breakpoints.Mobile, value: 'absolute' },
                      ],
                      right: [
                        { minWidth: Breakpoints.Laptop, value: 8 },
                        { minWidth: Breakpoints.Mobile, value: 8 },
                      ],
                      top: [
                        { minWidth: Breakpoints.Mobile, value: 12 },
                        { minWidth: Breakpoints.Laptop, value: 10 },
                      ],
                    },
                    dimensions.width
                  )}
                />
              </View>
              {/* View 2 */}
              <View>
                {/* Confirm Password */}
                <TextInput
                  autoCapitalize={'none'}
                  autoCorrect={true}
                  changeTextDelay={500}
                  onChangeText={newConfirmPasswordValue => {
                    try {
                      setConfirmPassword(newConfirmPasswordValue);
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                  webShowOutline={true}
                  {...GlobalStyles.TextInputStyles(theme)['Mobile Password']
                    .props}
                  keyboardType={'visible-password'}
                  placeholder={'Confirm New Pasword'}
                  secureTextEntry={!visibleConfirm}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.TextInputStyles(theme)['Mobile Password']
                        .style,
                      {
                        backgroundColor: {
                          minWidth: Breakpoints.Desktop,
                          value: palettes.Brand.White,
                        },
                      }
                    ),
                    dimensions.width
                  )}
                  value={confirmPassword}
                />
                <IconButton
                  onPress={() => {
                    try {
                      setVisibleConfirm(!visibleConfirm);
                    } catch (err) {
                      console.error(err);
                    }
                  }}
                  color={StyleSheet.getWidthValue(
                    [
                      {
                        minWidth: Breakpoints.Laptop,
                        value: palettes.Brand.Black,
                      },
                      {
                        minWidth: Breakpoints.Mobile,
                        value: palettes.Brand.Black,
                      },
                    ],
                    dimensions.width
                  )}
                  icon={
                    visibleConfirm ? 'FontAwesome/eye' : 'FontAwesome/eye-slash'
                  }
                  size={StyleSheet.getWidthValue(
                    [
                      { minWidth: Breakpoints.Laptop, value: 24 },
                      { minWidth: Breakpoints.Mobile, value: 24 },
                    ],
                    dimensions.width
                  )}
                  style={StyleSheet.applyWidth(
                    {
                      position: [
                        { minWidth: Breakpoints.Laptop, value: 'absolute' },
                        { minWidth: Breakpoints.Mobile, value: 'absolute' },
                      ],
                      right: [
                        { minWidth: Breakpoints.Laptop, value: 8 },
                        { minWidth: Breakpoints.Mobile, value: 8 },
                      ],
                      top: [
                        { minWidth: Breakpoints.Mobile, value: 8 },
                        { minWidth: Breakpoints.Laptop, value: 10 },
                      ],
                    },
                    dimensions.width
                  )}
                />
              </View>
            </View>
          )}
        </>
        {/* Buttons */}
        <View
          style={StyleSheet.applyWidth(
            {
              alignItems: [
                { minWidth: Breakpoints.Laptop, value: 'center' },
                { minWidth: Breakpoints.Mobile, value: 'center' },
              ],
              marginTop: [
                { minWidth: Breakpoints.Laptop, value: '10%' },
                { minWidth: Breakpoints.Mobile, value: 50 },
              ],
              width: { minWidth: Breakpoints.Laptop, value: '100%' },
            },
            dimensions.width
          )}
        >
          {/* Error Message */}
          <>
            {!errorMessage ? null : (
              <Text
                accessible={true}
                selectable={false}
                {...GlobalStyles.TextStyles(theme)['Text'].props}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.TextStyles(theme)['Text'].style,
                    {
                      color: [
                        {
                          minWidth: Breakpoints.Laptop,
                          value: palettes.Brand['App Red'],
                        },
                        {
                          minWidth: Breakpoints.Desktop,
                          value: theme.colors.background.brand,
                        },
                        {
                          minWidth: Breakpoints.Mobile,
                          value: palettes.Brand['App Red'],
                        },
                      ],
                      fontFamily: [
                        {
                          minWidth: Breakpoints.Laptop,
                          value: 'OpenSans_400Regular',
                        },
                        {
                          minWidth: Breakpoints.Mobile,
                          value: 'OpenSans_400Regular',
                        },
                      ],
                      fontSize: [
                        { minWidth: Breakpoints.Desktop, value: 18 },
                        { minWidth: Breakpoints.Laptop, value: 14 },
                      ],
                      marginBottom: { minWidth: Breakpoints.Laptop, value: 10 },
                      paddingBottom: [
                        { minWidth: Breakpoints.Desktop, value: 4 },
                        { minWidth: Breakpoints.Laptop, value: 4 },
                        { minWidth: Breakpoints.Mobile, value: 6 },
                      ],
                      paddingTop: { minWidth: Breakpoints.Laptop, value: 4 },
                      textAlign: [
                        { minWidth: Breakpoints.Laptop, value: 'center' },
                        { minWidth: Breakpoints.Mobile, value: 'center' },
                      ],
                    }
                  ),
                  dimensions.width
                )}
              >
                {errorMessage}
              </Text>
            )}
          </>
          {/* Submit */}
          <Button
            accessible={true}
            iconPosition={'left'}
            onPress={() => {
              const handler = async () => {
                try {
                  if (flowStep === 1) {
                    if (inputValid()) {
                      return;
                    }
                    setIsLoading(true);
                    const result = (
                      await authenticationInitiateForgotPasswordPOST.mutateAsync(
                        { email: email }
                      )
                    )?.json;
                    if (result?.status) {
                      setFlowStep(2);
                      setErrorMessage('');
                    } else {
                      setErrorMessage(result?.message);
                    }

                    setIsLoading(false);
                  } else {
                  }

                  if (flowStep === 2) {
                    setIsLoading(true);
                    const resultVerify = (
                      await authenticationVerifyOTPPOST.mutateAsync({
                        email: email,
                        otp: otp,
                      })
                    )?.json;
                    if (resultVerify?.authToken) {
                      setGlobalVariableValue({
                        key: 'AUTH_TOKEN',
                        value: resultVerify?.authToken,
                      });
                      setFlowStep(3);
                      setErrorMessage('');
                    } else {
                      setErrorMessage(resultVerify?.message);
                    }

                    setIsLoading(false);
                  } else {
                  }

                  if (flowStep === 3) {
                    const foundError = passwordValid();
                    if (foundError) {
                      return;
                    }
                    setIsLoading(true);
                    const resultUpdate = (
                      await authenticationUpdatePasswordPOST.mutateAsync({
                        new_password: password,
                      })
                    )?.json;
                    if (resultUpdate?.status) {
                      showAlertUtil({
                        title: undefined,
                        message: resultUpdate?.status,
                        buttonText: 'OK',
                      });

                      setGlobalVariableValue({
                        key: 'AUTH_TOKEN',
                        value: '',
                      });
                      resetVariables();
                      navigation.navigate('LoginScreen');
                    } else {
                      undefined;
                    }
                  } else {
                  }

                  setIsLoading(false);
                } catch (err) {
                  console.error(err);
                }
              };
              handler();
            }}
            {...GlobalStyles.ButtonStyles(theme)['New Submit Button'].props}
            loading={isLoading}
            style={StyleSheet.applyWidth(
              StyleSheet.compose(
                GlobalStyles.ButtonStyles(theme)['New Submit Button'].style,
                {
                  backgroundColor: palettes.Brand['App Green'],
                  color: theme.colors.background.brand,
                  maxWidth: 100,
                  paddingLeft: [
                    { minWidth: Breakpoints.Mobile, value: 20 },
                    { minWidth: Breakpoints.Laptop, value: 0 },
                  ],
                  paddingRight: [
                    { minWidth: Breakpoints.Mobile, value: 20 },
                    { minWidth: Breakpoints.Laptop, value: 0 },
                  ],
                  width: 100,
                }
              ),
              dimensions.width
            )}
            title={'Submit'}
          />
          {/* Cancel Link */}
          <Link
            accessible={true}
            onPress={() => {
              try {
                resetVariables();
                setGlobalVariableValue({
                  key: 'AUTH_TOKEN',
                  value: '',
                });
                navigation.navigate('LoginScreen');
              } catch (err) {
                console.error(err);
              }
            }}
            selectable={false}
            style={StyleSheet.applyWidth(
              {
                color: palettes.Brand['App Green'],
                fontFamily: 'OpenSans_600SemiBold',
                fontSize: 16,
                marginTop: [
                  { minWidth: Breakpoints.Laptop, value: 50 },
                  { minWidth: Breakpoints.Mobile, value: 20 },
                ],
                textAlign: 'center',
                textTransform: 'uppercase',
              },
              dimensions.width
            )}
            title={'Cancel'}
          />
        </View>
      </SimpleStyleScrollView>
    </ScreenContainer>
  );
};

export default withTheme(ForgotPasswordScreen);
